import authService from "@/services/auth.service";
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from "react";

interface AuthContextValue {
  user: any | null;
  setCurrentUser: (userData: any) => void;
  logout: () => void;
  loaderUser: () => void;
  loading:boolean
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any | null>(null);
  const [loading, setloading] = useState(true);

  const setCurrentUser = (user:any) => {
    console.log("AuthContext - setCurrentUser called with:", user);
    setloading(false);
    if (user) {
      setUser(user);
    } else {
      setUser(undefined);
    }
  };

  const logout = () => {
    setUser(null);
  };

  const loaderUser = async () => {
    try {
      const token = authService.getToken();
      if (!token) {
        setCurrentUser(null);
        return;
      }
      const authData: any = await authService.getCurrentUser();
      setCurrentUser(authData);
    } catch (error) {
      console.error("Error loading user:", error);
      setCurrentUser(null);
    }
  };

  const contextValue = useMemo(
    () => ({
      user,
      setCurrentUser,
      logout,
      loading,
      loaderUser,
      setloading,
    }),
    [user, loading]
  );

  useEffect(() => {
    loaderUser();
  }, []);

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
